module.exports = __webpack_public_path__ + "static/book-492x328-4f9547abd750f72b1dc26e5813667214.jpg";